import React from 'react';
import { EnhancedDashboardIllustration } from './EnhancedDashboardIllustration';

export const HeroIllustration: React.FC = () => {
  return <EnhancedDashboardIllustration />;
};
